import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import styles from 'components/FloatingCreateButton.css';

const FloatingCreateButton = ({ isCancel, onCreate, onCancel }) =>
  <Button
    className={isCancel ? styles.cancelButton : styles.createButton}
    icon={isCancel ? 'close' : 'add'}
    onClick={isCancel ? onCancel : onCreate}
    floating
    accent
  />;

export default FloatingCreateButton;
